import React from 'react'
import styled from 'styled-components'
import { useFormContext } from 'react-hook-form'
import get from 'lodash/get'

export const ErrorLabel = styled.small`
  display: block;
  color: ${({ theme }) => theme?.['-ds-error-300']?.value};
  font-weight: normal;
  font-size: 12px;
  margin-bottom: 16px;
  margin-right: 16px;
`

const ErrorMessage: React.FC<{ name: string }> = ({ name }) => {
  const {
    formState: { errors },
  } = useFormContext()
  const error = get(errors, name)
  if (!error) return null

  return <ErrorLabel>{error.message}</ErrorLabel>
}

export default ErrorMessage
